import { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import logo from "../assets/images/Datara_Icon_Black.png";
import logo_cuted from "../assets/images/Datara_Cuted.png";
import Context from "../context/Context";
import Cookies from 'js-cookie';
import { businessAndEnterpriseModeTeamSidebar, companyMemberSidebar, personalModeSidebar } from "./common/sidebarContent";
import { IoSparklesSharp } from "react-icons/io5";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import { IoSettingsSharp,  } from "react-icons/io5";
import StorageSection from "./common/sidebarStorage/StorageSection";
import { IoMdHelpCircle } from "react-icons/io";
const ACCENT_COLOR_BG = 'bg-[#fff]';


const Sidebar2 = () => {
    const { user, isSidebarOpen, setSidebarOpen } = useContext(Context);
    const [openDropdown, setOpenDropdown] = useState(null);
    const token = Cookies.get('authToken');
    const navigate = useNavigate();
    const location = useLocation();

    const getActualSidebar = () => {
        const businessRoles = ['Company Head', 'Team Head', 'Member'];

        if (businessRoles.includes(user?.role)) return businessAndEnterpriseModeTeamSidebar;
        if (user?.role === 'Company Member') return companyMemberSidebar;
        if (user?.role === 'Personal User') return personalModeSidebar;
    };

    const actualSidebar = getActualSidebar();

    const toggleSidebar = () => {
        setSidebarOpen(!isSidebarOpen);
    };

    const handleItemClick = () => {
        localStorage.removeItem('breadcrumb');
        setOpenDropdown(null);
    }

    useEffect(() => {
        actualSidebar?.forEach((item, index) => {
            if (item.children) {
                const hasActiveChild = item.children.some(child => child.link === location.pathname);
                if (hasActiveChild) {
                    setOpenDropdown(index);
                }
            }
        });
    }, [location.pathname, actualSidebar]);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setSidebarOpen(false);
            } else {
                setSidebarOpen(true);
            }
        };

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, [setSidebarOpen]);

    useEffect(() => {
        if (!token) {
            Cookies.remove('authToken');
            navigate('/login');
        }
    }, [token]);

    return (
        <div className={`sidebar z-40 ${isSidebarOpen ? "open" : ""}`}>
            {!isSidebarOpen && <i className={`icon ${isSidebarOpen ? " mt-4" : "flex items-center justify-center gap-1"} ml-[17px]`}>
                <img
                    src={logo}
                    alt="logo"
                    height={30}
                    width={30}
                    style={{ filter: 'invert(1)' }}
                />
                <i
                    className={`flex bx ${isSidebarOpen ? "bx-menu-alt-right" : "flex items-center cursor-pointer"} bx-sm`}
                    id="btn"
                    onClick={toggleSidebar}
                ><MdKeyboardArrowRight size={23} /></i>
            </i>}
            <div className="logo-details ">
                {isSidebarOpen && <i className={`icon ${isSidebarOpen ? "" : " "} mt-4 ml-1`}>
                    <img
                        src={logo}
                        alt="logo"
                        height={30}
                        width={30}
                        style={{ filter: 'invert(1)' }}
                    />
                </i>}
                {isSidebarOpen && (
                    <div className="logo_container ml-2 mb-2">
                        <img
                            src={logo_cuted}
                            alt="logo_cuted"
                            style={{ filter: 'invert(1)' }}
                        />
                    </div>
                )}

                {isSidebarOpen && <i
                    //  className={`flex bx ${isSidebarOpen ? "bx-menu-alt-right" : "bx-menu"} bx-sm`}
                    className="flex items-center justify-center"
                    id="btn"
                    onClick={toggleSidebar}
                ><MdKeyboardArrowLeft />
                </i>}
            </div>

            <ul className={`nav-list !mb-0 flex justify-between flex-col flex-grow overflow-y-auto overflow-x-hidden custom-sidebar-scroll ${!isSidebarOpen && 'mt-[-60px]'}`}>
                <div>
                {actualSidebar?.map((item, index) => (
                    <li key={index} className={`sidebar-item cursor-pointer ${isSidebarOpen && '!pl-[8px]'}`}>
                        {item.children ? (
                            <>
                                <div
                                    className={`sidebar-parent d-flex align-items-center justify-content-between ${openDropdown === index ? "active" : ""}`}
                                    onClick={() => setOpenDropdown(openDropdown === index ? null : index)}
                                >
                                    <div className="d-flex align-items-center w-full">
                                        {typeof item.icon === "string" ? (
                                            <i className={`bx ${item.icon} `}></i>
                                        ) : (
                                            <i className={`flex items-center ${!isSidebarOpen ? 'justify-center w-full' : ''}`}><item.icon size={18} className="sidebar-icon" /></i>
                                        )}
                                        <div className="flex items-center justify-between w-full">
                                        {isSidebarOpen && <span className="links_name ">{item.name}</span>}
                                        <i className={`flex bx bx-chevron-${openDropdown === index ? "down" : "right"} `}></i>
                                        </div>
                                    </div>

                                </div>
                                {openDropdown === index && (
                                    <ul className="submenu">
                                        {item.children.map((child, childIndex) => (
                                            <li key={childIndex}>
                                                <Link
                                                    to={child.link}
                                                    className={location.pathname === child.link ? "active-link" : ""}
                                                    onClick={handleItemClick}
                                                >
                                                    {typeof child.icon === "string" ? (
                                                        <i className={`bx ${child.icon}  `}></i>
                                                    ) : (
                                                        <i className={`flex items-center ${!isSidebarOpen ? 'justify-center w-full' : 'justify-center'}`}><child.icon size={18} className="sidebar-icon ml-1" /></i>
                                                    )}
                                                    <span className="links_name ">{child.name}</span>
                                                </Link>
                                                <span className="tooltip">{child?.name}</span>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </>
                        ) : (
                            <Link
                                to={item.link}
                                className={`${(location.pathname === item.link && openDropdown === null) ? "active-link" : ""} ${!isSidebarOpen ? 'justify-center' : ''}`}
                                onClick={handleItemClick}
                            >
                                {typeof item.icon === "string" ? (
                                    <i className={`bx ${item.icon} `}></i>
                                ) : (
                                    <i className={`flex items-center ${!isSidebarOpen ? 'justify-center w-full' : 'justify-center'}`}><item.icon size={18} className="sidebar-icon " /></i>
                                )}
                                {isSidebarOpen && <span className="links_name ">{item.name}</span>}
                            </Link>
                        )}
                        {openDropdown !== index && <span className="tooltip">{item?.name}</span>}
                    </li>
                ))}
                </div>


                <li className={`px-2 pt-5 ${!isSidebarOpen && '!mt-[80px]'}`}>
                    {isSidebarOpen ? (
                        <div className="bg-[#000000] p-3 rounded-[4px] shadow-lg border border-[#2D2D2D]">
                            <div className={`text-2xl font-bold mb-1 text-warning flex items-center `}>
                                <IoSparklesSharp className="w-6 h-6 mr-1 !mb-2 text-[#FFB030]" />
                                <h3 className="text-lg font-bold text-white">Upgrade to Pro</h3>
                            </div>
                            <p className="text-xs text-[#FFFFFF] mb-3 leading-snug">
                                Our new Artificial Intelligence that will improve your sheet performance
                            </p>
                            <button
                                className={`
                                    w-full py-2 ${ACCENT_COLOR_BG} text-gray-900 
                                    rounded-[4px] text-sm font-bold transition duration-200 
                                    hover:bg-opacity-90 hover:shadow-md active:scale-[0.98]
                                `}
                                onClick={() => {
                                    navigate('/plans');
                                }}
                            >
                                Try Now
                            </button>
                        </div>
                    ) : (
                        <div
                            onClick={() => navigate('/plans')}
                            className="flex items-center justify-center p-2 bg-[#1a1a2e] rounded-lg cursor-pointer border border-[#2D2D2D] hover:bg-[#252540] transition-colors"
                        >
                            <IoSparklesSharp className="w-5 h-5 text-[#FFB030]" />
                        </div>
                    )}
                </li>

                <li className="px-2 pt-2 !mt-auto">
                    <StorageSection isSidebarOpen={isSidebarOpen} />
                </li>


            </ul>

            <div className="flex-shrink-0 mt-2">
                <div className="border-t border-[#2D2D2D] !mx-2 !mr-4"></div>
                <ul className="list-none p-0 m-0 py-2">
                    <li className={`relative group ${isSidebarOpen && '!pl-[8px]'}`}>
                        <Link
                            to="/settings"
                            //  className={`flex py-2 hover:bg-[#19202C] rounded-md transition-colors ${!isSidebarOpen ? 'justify-center' : ''}`}
                            className={`${location.pathname === '/settings' ? "active-link" : ""} ${!isSidebarOpen ? 'justify-center' : ''}`}


                        >
                            <i className={`flex items-center ${!isSidebarOpen ? 'justify-center w-full' : 'justify-center'}`}><IoSettingsSharp size={18} className='sidebar-icon' /></i>
                            {isSidebarOpen && <span className="links_name">Settings</span>}
                        </Link>
                        {!isSidebarOpen && <span className="tooltip">Settings</span>}
                    </li>
                    <li className={`relative group ${isSidebarOpen && '!pl-[8px]'}`}>
                        <Link
                            to="/help"
                            // className={`flex py-2 hover:bg-[#19202C] rounded-md transition-colors ${!isSidebarOpen ? 'justify-center' : ''}`}
                            className={`${location.pathname === '/help' ? "active-link" : ""} ${!isSidebarOpen ? 'justify-center' : ''}`}
                        >
                           <i className={`flex items-center ${!isSidebarOpen ? 'justify-center w-full' : 'justify-center'}`}><IoMdHelpCircle size={18} className='sidebar-icon' /></i>
                            {isSidebarOpen && <span className="links_name ">Help</span>}
                        </Link>
                        {!isSidebarOpen && <span className="tooltip">Help</span>}
                    </li>
                </ul>
            </div>

        </div>
    );
};

export default Sidebar2;
